import React, { useMemo } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const MonthlyChatsChart = ({ chats }) => {
  const monthlyChatsData = useMemo(() => {
    const months = {};
    const currentDate = new Date();
    
    // Inicializar últimos 12 meses
    for (let i = 11; i >= 0; i--) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      months[key] = 0;
    }

    // Contar chats nuevos por mes (basado en createdAt)
    chats.forEach(chat => {
      if (chat.createdAt) {
        const chatDate = chat.createdAt?.toDate ? chat.createdAt.toDate() : new Date(chat.createdAt);
        const key = `${chatDate.getFullYear()}-${String(chatDate.getMonth() + 1).padStart(2, '0')}`;
        
        if (months.hasOwnProperty(key)) {
          months[key]++;
        }
      }
    });

    return months;
  }, [chats]);

  const data = {
    labels: Object.keys(monthlyChatsData).map(key => {
      const [year, month] = key.split('-');
      const date = new Date(year, month - 1);
      return date.toLocaleDateString('es-ES', { month: 'short', year: '2-digit' });
    }),
    datasets: [
      {
        label: 'Nuevos Chats',
        data: Object.values(monthlyChatsData),
        backgroundColor: 'rgba(153, 102, 255, 0.8)',
        borderColor: 'rgba(153, 102, 255, 1)',
        borderWidth: 1,
        borderRadius: 4,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 10,
        bottom: 10,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
        align: 'start',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 20,
          font: {
            size: 12,
            weight: '500',
          },
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: true,
        titleFont: {
          size: 14,
          weight: 'bold',
        },
        bodyFont: {
          size: 13,
        },
        callbacks: {
          label: function(context) {
            return `Nuevos chats: ${context.parsed.y}`;
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.05)',
          borderDash: [2, 2],
        },
        ticks: {
          font: {
            size: 11,
            weight: '500',
          },
          color: '#666',
        },
        title: {
          display: false,
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.05)',
          borderDash: [2, 2],
        },
        ticks: {
          precision: 0,
          font: {
            size: 11,
            weight: '500',
          },
          color: '#666',
        },
        title: {
          display: false,
        }
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
  };

  return <Bar data={data} options={options} />;
};

export default MonthlyChatsChart;
